// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1iDAH","vLegacy":"SelectSecondary_vLegacy__4p-yG","error":"SelectSecondary_error__3riQp","disabled":"SelectSecondary_disabled__2kO5F"};